import { CustomError } from './CustomError';

export class LiveStatusCheckError extends CustomError {
	description = 'There was a problem checking the live status';
	name = 'LiveStatusCheckError';
}
